"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ToolbarDivider = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * AppShell — the masthead, toolbar band and content region shared by Console,
 * Designer and Survey Explorer. Implements surface-identity-and-shell.md §2.
 * No application reimplements this.
 *
 *   <AppShell
 *     surface="console"                    // sets the tint class
 *     wordmark="Console"                   // rendered caps, letter-spaced
 *     logo={<SamLogo size={26} variant="light" />}
 *     help={<Button variant="onDark" ghost onClick={…}>Help</Button>}
 *     toolbarLeft={…} toolbarCentre={…} toolbarRight={…}
 *   >
 *     …panels…
 *   </AppShell>
 *
 * The logo is passed in rather than bundled: it is displayed exactly as each app
 * displays it today, never recoloured and never swapped per surface.
 *
 * Toolbar groups are fixed by the standard — left: actions on the current object;
 * centre: surface/view switching; right: session and account. Use <ToolbarDivider>
 * between groups; never separate them with extra whitespace.
 */const AppShell = ({
  surface,
  wordmark,
  logo,
  help,
  toolbarLeft,
  toolbarCentre,
  toolbarRight,
  toolbar,
  status,
  children,
  contentClassName = '',
  contentStyle,
  className = ''
}) => {
  // `toolbar` is a TRANSITIONAL escape hatch: it renders an app's existing
  // toolbar component inside the band unchanged, so an app can adopt the shared
  // masthead before its controls have been regrouped into left/centre/right.
  // Prefer the three group props. Remove uses of `toolbar` as each app completes
  // its own remediation phase.
  const hasToolbar = toolbar || toolbarLeft || toolbarCentre || toolbarRight || status;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `appshell ${surface ? `app--${surface}` : ''} ${className}`.trim(),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
      className: "appshell__masthead",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "appshell__masthead-spacer"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "appshell__brand",
        children: [logo, wordmark && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "appshell__wordmark",
          children: wordmark
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "appshell__masthead-end",
        children: help
      })]
    }), hasToolbar && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `appshell__toolbar${toolbar ? ' appshell__toolbar--raw' : ''}`,
      children: toolbar || /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "appshell__toolbar-group appshell__toolbar-left",
          children: [toolbarLeft, status && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "appshell__status",
            children: status
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "appshell__toolbar-group appshell__toolbar-centre",
          children: toolbarCentre
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "appshell__toolbar-group appshell__toolbar-right",
          children: toolbarRight
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("main", {
      className: `appshell__content ${contentClassName}`.trim(),
      style: contentStyle,
      children: children
    })]
  });
};

/** 1px × 22px rule between toolbar groups. Never separate groups with whitespace. */
const ToolbarDivider = () => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
  className: "appshell__divider",
  "aria-hidden": "true"
});
exports.ToolbarDivider = ToolbarDivider;
var _default = exports.default = AppShell;